<template>
    <b-modal
        ref="create-or-update-project"
        v-model="modalShow"
        title-class="text-light"
        header-bg-variant="dark"
        header-text-variant="light"
        title-tag="h4"
        centered
        :no-close-on-backdrop="true"
        :title="
            projectData.id
                ? `Edit ${project.name} project`
                : 'Create new project'
        "
        :hide-header-close="true"
        :no-close-on-esc="true"
        :hide-footer="true"
        body-class="modal-body"
        size="xl"
        persistent
    >
        <div class="modal-content  border-0 p-0">
            <div class="modal-body">
                <br />
                <div class="col-12 form-group">
                    <div class="col-6" style="float: left;">
                        <div>
                            <label> Project name</label>
                            <input
                                v-model="projectData.name"
                                type="text"
                                class="form-control"
                                dir="auto"
                            />
                        </div>
                        <br />
                    </div>
                    <div class="col-6" style="float: left;">
                        <label>Select city</label>

                        <vue-typeahead-bootstrap
                            v-model="projectData.city"
                            :show-on-focus="true"
                            :min-matching-chars="0"
                            :max-matches="25"
                            :data="cities"
                            :serializer="
                                item =>
                                    item.nameInHebrew
                                        ? `${item.nameInHebrew} - climate ${item.climate}`
                                        : item
                            "
                            placeholder="Type name of the city in Hebrew that you want to choose"
                            @hit="city = $event"
                            @input="fetchCities({ q: projectData.city })"
                        />

                        <div v-if="city" class="mt-3">
                            Selected city:
                            <strong>
                                {{ city.nameInHebrew }}
                            </strong>
                            - climate
                            <strong>
                                {{ city.climate }}
                            </strong>
                        </div>
                        <div v-else>
                            Selected city:
                            <strong>
                                {{ projectData.city }}
                            </strong>
                            - climate
                            <strong>
                                {{ projectData.climate }}
                            </strong>
                        </div>

                        <br />
                    </div>

                    <div class="col-6" style="float: right;">
                        <div>
                            <label> Select weather file</label>
                            <v-select
                                v-model="projectData.weatherFile"
                                :options="
                                    weatherFiles.map(
                                        weatherFile => weatherFile.name
                                    )
                                "
                                :menu-props="{ top: true, offsetY: true }"
                                label="filename"
                                item-value="name"
                                item-text="filename"
                                class="mb-2"
                                style="width: 100%"
                            />
                        </div>
                        <br />
                    </div>
                    <div class="col-6" style="float: right;">
                        <div>
                            <label> Surface type to rate</label>
                            <div>
                                <v-select
                                    v-model="projectData.surfaceTypeToRate"
                                    label="label"
                                    :options="selectOptions"
                                    :reduce="
                                        surfaceTypeToRate =>
                                            surfaceTypeToRate.value
                                    "
                                    :menu-props="{ top: true, offsetY: true }"
                                    class="mb-2"
                                    style="width: 100%"
                                    placeholder="Select type of the surface for rating calculation"
                                />
                            </div>
                        </div>

                        <br />
                    </div>
                    <div class="col-6" style="float: left;">
                        <div>
                            <label> Company name</label>
                            <input
                                v-model="projectData.companyName"
                                type="text"
                                class="form-control"
                                dir="auto"
                            />
                        </div>
                        <br />
                    </div>
                    <div class="col-6" style="float: left;">
                        <div>
                            <label> Address</label>
                            <input
                                v-model="projectData.address"
                                type="text"
                                class="form-control"
                                dir="auto"
                            />
                        </div>
                        <br />
                    </div>
                    <div class="col-6" style="float: right;">
                        <div>
                            <label> Block</label>
                            <input
                                v-model="projectData.block"
                                type="text"
                                class="form-control"
                                dir="auto"
                            />
                        </div>
                        <br />
                    </div>

                    <div class="col-6" style="float: left;">
                        <div>
                            <label> Plot</label>
                            <input
                                v-model="projectData.plot"
                                type="text"
                                class="form-control"
                                dir="auto"
                            />
                        </div>
                        <br />
                    </div>

                    <div class="col-6" style="float: left;">
                        <div>
                            <label>
                                Select mass per unit area of exterior walls (kg
                                / m²)
                            </label>
                            <v-select
                                v-model="projectData.massPerUnit"
                                item-text="label"
                                :reduce="massPerUnit => massPerUnit.key"
                                :options="massPerUnitOptions"
                                :menu-props="{ top: true, offsetY: true }"
                                class="mb-2"
                                style="width: 100%"
                                placeholder="Select mass per unit"
                            />
                        </div>
                        <br />
                    </div>

                    <div class="col-6" style="float: right;">
                        <div>
                            <label> U-Value of wall bridge</label>
                            <input
                                v-model="projectData.uValueOfWallBridge"
                                type="number"
                                class="form-control"
                                dir="auto"
                            />
                        </div>
                        <br />
                    </div>

                    <div class="col-6" style="float: left;">
                        <div>
                            <label> Percentage of wall bridge </label>

                            <b-input-group>
                                <b-form-input
                                    v-model="projectData.wallBridgePercentage"
                                    :value="+'%'"
                                    type="number"
                                    class="form-control"
                                    dir="auto"
                                />
                                <b-input-group-text
                                    class="md-suffix bg-transparent border-left-0"
                                >
                                    %
                                </b-input-group-text>
                            </b-input-group>
                            <br />
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer p-4" style="display:block;">
                <div style="float:left;">
                    <button
                        class="btn pl-5 pr-5 btn-success waves-effect waves-light"
                        data-animation="fadein"
                        data-overlaycolor="#38414a"
                        @click="save"
                    >
                        Save
                    </button>
                </div>
                <div style=" float:right;">
                    <button
                        class="btn pl-5 pr-5 btn-danger waves-effect waves-light"
                        data-animation="fadein"
                        data-overlaycolor="#38414a"
                        @click="close"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import vueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

export default {
    page: {
        title: 'Greener - Calculations Requests'
    },

    components: {
        vueTypeaheadBootstrap
    },

    props: {
        modalShow: Boolean,
        project: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        const defaultFormData = {
            uValueOfWallBridge: 2,
            wallBridgePercentage: 10,
            massPerUnit: null,
            name: '',
            city: '',
            climate: '',
            companyName: '',
            weatherFile: '',
            address: '',
            plot: '',
            block: '',
            surfaceTypeToRate: ''
        };

        return {
            defaultFormData,
            massPerUnitOptions: [
                { key: 110, label: '> 100' },
                { key: 90, label: '< 100' }
            ],
            selectOptions: [
                {
                    value: 'residential_rating_calculations',
                    label: 'Residential rating'
                },
                { value: 'office_rating_calculations', label: 'Office rating' }
            ],
            projectData: { ...defaultFormData },
            energyPlusVersion: '',
            companyName: '',
            weatherFiles: [],
            cities: [],
            city: null
        };
    },

    watch: {
        modalShow() {
            if (!this.project) {
                return;
            }
            this.projectData = {
                ...this.project
            };
        }
    },

    async created() {
        await this.getWeatherFiles();
        await this.fetchCities();
    },

    methods: {
        ...mapActions({
            getFiles: 'files/index',
            getCities: 'cities/index',
            saveProject: 'projects/save'
        }),

        setDefaultData() {
            this.projectData = { ...this.defaultFormData };
            this.city = null;
        },

        async getWeatherFiles() {
            try {
                const { rows } = await this.getFiles({
                    searchParams: { type: 'weather_files' }
                });

                this.weatherFiles = [...rows];
            } catch (error) {
                console.error(error);
            }
        },

        async fetchCities(searchParams) {
            try {
                this.cities = await this.getCities({
                    searchParams
                });
            } catch (error) {
                console.error(error);
            }
        },

        async save() {
            try {
                if (!this.projectData.id) {
                    this.projectData.city = this.city.nameInHebrew;
                    this.projectData.climate = this.city.climate;
                }

                await this.saveProject(this.projectData);

                this.close();
            } catch (error) {
                console.error(error);
            }
        },

        close() {
            this.$emit('close');
            setTimeout(this.setDefaultData, 100);
        }
    }
};
</script>

<style>
.modal-body {
    padding: 0;
}
</style>
